
var Stmt = require('./stmt');

/**
 * The equivalent of a SQL delete.
 */
module.exports = new Class({
	Extends: Stmt
	,Tag: 'sql-delete'

	,render(params) {
		return 'DELETE FROM'
			+ this.renderTarget(params)
			+ this.renderIfSet(this.where, 'WHERE', params)
			+ this.renderLimit(params);
	}
});
